<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-vr-cardboard', fontSet: 'fad'}"
	[headerText]="T.CREATE_VIRTUAL_ROOM_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<form [formGroup]="createVirtualRoomForm" class="createVirtualRoomForm">
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.SIM_ROOM_PLANNER_ROOM_NAME | translate }}</mat-label>
				<input formControlName="roomName" matInput placeholder="Room Name" type="text" />
				@if (createVirtualRoomForm.controls.roomName.hasError("required")) {
					<mat-error>
						{{ T.CREATE_VIRTUAL_ROOM_DIALOG_ERROR_MESSAGE_ROOM_REQUIRED | translate }}
					</mat-error>
				}
			</mat-form-field>
			<sim-room-chip-input
				[canSelectMultipleRooms]="true"
				[roomFc]="createVirtualRoomForm.controls.combinedRooms"
				label="Combined Rooms"
				placeholder="Combined Rooms"
			/>

			@if (!createVirtualRoomForm.controls.combinedRooms.length) {
				<div [@zoomInOnEnter] class="noRoomsSelectedInfoDialog">
					{{ T.CREATE_VIRTUAL_ROOM_DIALOG_MESSAGE | translate }}
				</div>
			}

			@if (createVirtualRoomForm.controls.combinedRooms.length) {
				<div class="combinedRoomsOverview">
					@for (selectedRoom of createVirtualRoomForm.controls.combinedRooms.value; track selectedRoom) {
						<sim-training-room-button [draggable]="false" [isButtonView]="false" [trainingRoom]="selectedRoom" />
					}
				</div>
			}
		</form>
	</ng-container>

	<ng-container actions>
		<button (click)="cancel()" color="warn" mat-raised-button style="margin-right: 15px">
			{{ T.CREATE_VIRTUAL_ROOM_DIALOG_CANCEL_BUTTON | translate }}
		</button>

		<button (click)="createVirtualRoom()" [disabled]="createVirtualRoomForm.invalid || !onceCreation" color="accent" mat-raised-button>
			{{ T.CREATE_VIRTUAL_ROOM_DIALOG_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
